import * as ActionTypes from 'state/types'
import history from 'shared/utils/history'

export const routerMiddleware = store => next => action => {
  switch(action.type) {
    case ActionTypes.REDIRECT_TO_ALL_MESSAGES: {
      history.push(`${process.env.CHAT_PUBLIC_PATH}/filter/all`)
    }
  }

  next(action)
}
